<template>
    <div class="innerBox">
  
      <h1>Kadaluarsa Polis</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox">
          <div class="col row">
            <!-- <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Cari</label>
              <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
            </div> -->
            <div class="col-md-4 col-12" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Perusahaan Asuransi</label>
              <!-- <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search"> -->
              <Multiselect 
                v-if="insuranceCompany"
                :options="insuranceCompany.map(x => x.id)"
                :custom-label="opt => insuranceCompany.find(x => x.id == opt).name"
                v-model="filter.insurance_company"
              />
            </div>
            <div class="col-md-4 col-12" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-4 col-12" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
      <vue-universal-table
        api_url="/api/v1/insurance/policy-expiry"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :fields="vue_universal_table.fields"
        :filter="filter"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'
    export default {
      components : {
        Multiselect
      },
      data () {
        let start = moment().startOf('month').format('Y-MM-DD')
        let end = moment().endOf('month').format('Y-MM-DD')
        return {
          mobile : this.isMobile(),
          modal : {
            view : false,
          },
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          selected : {
            date : `${start} to ${end}`,
          },
          filter : {
            search : '',
            start : start,
            end : end,
            insurance_company : null
          },
          vue_universal_table : {
            special_buttons : [],
            update : 0,
            export_config : {
              name : 'Outstanding Estimation',
              type : 'xlsx',
              all : true
            },
            fields : [{
              title : "Nomor Polisi",
              variable : 'nomor_polisi'
            },{
              title : "Tipe Mobil",
              variable : 'tipe_mobil'
            },{
              title : "Tahun Mobil",
              variable : 'tahun_mobil'
            }, {
              title : "Nomor Polis",
              variable : 'nomor_polis'
            },{
              title : "Tipe Polis",
              variable : 'tipe_polis'
            },{
              title : "Perusahaan Asuransi",
              variable : 'perusahaan_asuransi'
            },{
              title : "Tanggal Kadaluarsa",
              variable : 'tanggal_kadaluarsa',
              date_format : 'MMM DD, Y'
            }]
          },
          dummyData : null,
          insuranceCompany : null
        }
      },
      mounted () {
        this.generateData()
        this.getListOfInsuranceCompany()
      },
      watch : {
        'selected.date'(){
          var date = this.selected.date.split(" to ");
          this.filter.start = date[0]
          this.filter.end = date[1]
        }
      },
      methods : {
        viewDetail(a){
          console.log(JSON.parse(a).form_code);
          this.detailId = JSON.parse(a).form_code;
          this.modal.view = true;
        },
        generateData(){
            var names = ['Apple', 'Orange', 'Lemon', 'Kiwi', 'Pear']
            var dummy = []
            for(var i = 0; i < 15; i++){
                dummy.push({
                    woNumber : this.randomInt(1000000, 10000000),
                    total_sparepart : this.randomInt(1, 10),
                    total_price : this.randomInt(100000, 10000000),
                    insurance_name : names[this.randomInt(0,4)],
                    customer_name : names[this.randomInt(0,4)],
                })
            }
            this.dummyData = dummy
        },
        getListOfInsuranceCompany () {
          this.insuranceCompany = null;

          this.$http.get('/api/v1/insurance/company?pagination=false')
          .then((resp) => {
            this.insuranceCompany = resp.data.data.filter(x => x.name != 'Umum')
            // console.log(this.woList)
          })
          .catch((err) => { console.log(err) })
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>